import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private languageKey = 'selected_language';
  private defaultLanguage = 'geo';

  private currentLanguageSubject = new BehaviorSubject<string>(this.getSavedLanguage());
  public currentLanguage$ = this.currentLanguageSubject.asObservable();

  constructor() {}

  // ენის ამოღება localStorage-დან ან default
  private getSavedLanguage(): string {
    return localStorage.getItem(this.languageKey) || this.defaultLanguage;
  }

  // ენის შეცვლა (ინახავს და emits)
  setLanguage(lang: string): void {
    localStorage.setItem(this.languageKey, lang);
    this.currentLanguageSubject.next(lang);
  }

  // ენის მიღება (მყისიერი, არა Observable)
  getLanguage(): string {
    return this.currentLanguageSubject.value;
  }
  
}
